/**
 * API error processing helpers.
 *
 * Converts axios errors into user-facing message strings: processApiError
 * reads the backend's `description` field, processAiApiError reads the AI
 * service's `detail` field. Both log the status and rethrow non-axios
 * errors. Used by the shared axios layer (lib/axios.ts).
 */
import axios from "axios";

export function processApiError(error: any): string {
    if (axios.isAxiosError(error)) {
        const status = error.response?.status;
        const errorMessage = error.response?.data?.description ?? "Unknown error";
        console.error(`API Error: ${status} ${errorMessage}`);
        return errorMessage;
    }
    if (error === "Unauthorized") {
        return "Unauthorized";
    }
    throw Error(`Non Axios Error! ${error}`);
}

export function processAiApiError(error: any): string {
    if (axios.isAxiosError(error)) {
        const status = error.response?.status;
        const errorMessage = error.response?.data?.detail ?? "Unknown error";
        console.error(`AI API Error: ${status} ${errorMessage}`);
        return errorMessage;
    }
    throw Error(`Non Axios Error! ${error}`);
}
